import { OpenAdminBannerStatus } from "src/contexts/documentationArea/domain/OpenAdminBannerStatus";
import { CompletedOpenAdminBanner } from "./CompletedOpenAdminBanner";
import { ClosedOpenAdminBanner } from "./ClosedOpenAdminBanner";
import { InitialOpenAdminBanner } from "./InitialOpenAdminBanner";
import { InProgressOpenAdminBanner } from "./InProgressOpenAdminBanner";
import { PendingOpenAdminBanner } from "./PendingOpenAdminBanner";

export interface BasicBannerProps {
  title: string;
  description?: string;
  buttonText?: string;
  onButtonClick?: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
}

interface OpenAdminBannerByStatusProps extends BasicBannerProps {
  status: OpenAdminBannerStatus;
}

export const OpenAdminBannerByStatus = (props: OpenAdminBannerByStatusProps) => {
  const { status } = props;
  if (status === OpenAdminBannerStatus.COMPLETED) {
    return <CompletedOpenAdminBanner {...props} />;
  }

  if (status === OpenAdminBannerStatus.IN_PROGRESS) {
    return <InProgressOpenAdminBanner {...props} />;
  }

  if (status === OpenAdminBannerStatus.PENDING) {
    return <PendingOpenAdminBanner {...props} />;
  }

  if (status === OpenAdminBannerStatus.ERROR || status === OpenAdminBannerStatus.UNAVAILABLE) {
    return <ClosedOpenAdminBanner {...props} />;
  }

  return <InitialOpenAdminBanner {...props} />;
};
